import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { BookingResponse } from "@/api/types";

interface RescheduleBookingParams {
  id: string;
  scheduled_at: string;
}

export function useRescheduleBooking() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, scheduled_at }: RescheduleBookingParams) =>
      api.patch(`bookings/${id}`, { json: { scheduled_at } }).json<BookingResponse>(),
    onSuccess: (data, variables) => {
      void queryClient.invalidateQueries({ queryKey: ["bookings"] });
      void queryClient.invalidateQueries({
        queryKey: ["businesses", data.business.slug, "availability"],
      });
      void queryClient.invalidateQueries({ queryKey: ["dashboard"] });
      void queryClient.invalidateQueries({ queryKey: ["booking", variables.id] });
    },
  });
}
